import * as types from "../../../actions/types/index";
import {setInitialState} from "../../../util/utility";

const INITIAL_STATE = setInitialState({
    payload: null,
});

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.GET_PICTURE_DETAILS_REQUEST:
            return {
                ...state,
                isFetching: true,
                isSuccess: false,
                isError: false,
                payload:null,
            };
        case types.GET_PICTURE_DETAILS_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                payload: action.payload
            };
        case types.GET_PICTURE_DETAILS_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                payload: action.payload
            };
        case types.RESET_GET_PICTURE_DETAILS:
            return {
                ...state,
                payload: action.payload,
            };
        default:
            return {
                ...state
            }
    }
}